import api from 'Application/api/api';

const isProjectCustomSubsectionNameUnique = (
    name,
    projectId,
    sectionOrCustomTopicId,
    isCustomTopic,
    editedCustomSubsectionId = null,
    cancelToken = null,
) =>
    api.get(
        `project-manager/projects/${projectId}/questionnaire/sections/${sectionOrCustomTopicId}/${
            isCustomTopic ? 1 : 0
        }/custom-subsections/is-name-unique/${name}`,
        {
            params: {
                editedCustomSubsectionId,
            },
            cancelToken,
        },
    );

export default isProjectCustomSubsectionNameUnique;
